// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-angola/calculator-angola-business-loan-portuguese/calculator-angola-business-loan-portuguese.component.scss
// module id = 660
// module chunks = 0